import { customer } from "@api/orderings/customer/api";
import { employeeCost } from "@api/orderings/employeeCost/api";
import { measurementUnit } from "@api/orderings/measurementUnit/api";
import { paidInstallment } from "@api/orderings/paidInstallment/api";
import { productCategory } from "@api/orderings/productCategory/api";
import { productPlan } from "@api/orderings/productPlan/api";
import { purchaseInvoices } from "@api/orderings/purchaseInvoices/api";
import { salesInvoices } from "@api/orderings/salesInvoices/api";
import { store } from "@api/orderings/store/api";
import { storeCost } from "@api/orderings/storeCost/api";
import { subscription } from "@api/orderings/subscription/api";
import { supplier } from "@api/orderings/supplier/api";
import { unpaidInstallment } from "@api/orderings/unpaidInstallment/api";
import { user } from "@api/orderings/user/api";
import { warehouse } from "@api/orderings/warehouse/api";

export const orderings = {
  productPlan,
  store,
  subscription,
  paidInstallment,
  unpaidInstallment,
  warehouse,
  productCategory,
  measurementUnit,
  user,
  customer,
  supplier,
  storeCost,
  employeeCost,
  purchaseInvoices,
  salesInvoices,
};
